import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authApi } from '../../auth/auth';

const Navbar = () => {
  const navigate = useNavigate();
  const { user } = authApi.getAuthState();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleLogout = () => {
    authApi.logout();
    navigate('/login');
  };

  // Add API Calls link to the navigation items
  const navigationItems = [
    { name: 'Dashboard', href: '/' },
    { name: 'Test Suites', href: '/testsuites' },
    { name: 'Test Data', href: '/testdata' },
    { name: 'API Calls', href: '/api-calls' },
    { name: 'Settings', href: '/settings' }
  ];

  return (
    <header className="border-b">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <Link to="/testsuites" className="flex items-center">
          <img 
            src="/darknore-full-logo.svg" 
            alt="Darknore Logo" 
            className="h-8 w-auto"
          />
        </Link>
        <nav>
          <ul className="flex space-x-4">
            <li>
              <Link to="/testsuites" className="px-3 py-2 rounded hover:bg-gray-100">
                Test Suites
              </Link>
            </li>
            {/* <li>
              <Link to="#" className="px-3 py-2 rounded hover:bg-gray-100">
                Reports
              </Link>
            </li> */}
            <li>
              <Link to="/jobs" className="px-3 py-2 rounded hover:bg-gray-100">
                Test Runs
              </Link>
            </li>
            <li>
              <Link to="/testdata" className="px-3 py-2 rounded hover:bg-gray-100">
                Test Data
              </Link>
            </li>
            {/* <li>
              <Link to="/api-calls" className="px-3 py-2 rounded hover:bg-gray-100">
                API Calls
              </Link>
            </li> */}
          </ul>
        </nav>
        
        <div className="relative" ref={dropdownRef}>
          <button 
            className="flex items-center space-x-2 px-3 py-2 rounded hover:bg-gray-100 focus:outline-none"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className="text-sm text-gray-600 truncate max-w-[150px]">{user?.email}</span>
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          
          {isOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 border border-gray-200">
              <div className="px-4 py-2 border-b border-gray-200">
                <p className="text-sm font-medium text-gray-900 truncate">{user?.email}</p>
              </div>
              
              <Link 
                to="/me" 
                className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                onClick={() => setIsOpen(false)}
              >
                Settings
              </Link>
              
              <button 
                onClick={() => {
                  handleLogout();
                  setIsOpen(false);
                }}
                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;